(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8521],{

/***/ 96808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 92596:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance-pricing",
      function () {
        return __webpack_require__(73350);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ insurance_pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var dist_module = __webpack_require__(3912);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/TypeFilter.tsx




const TypeFilter = (param)=>{
    let { filters , toggleFilter  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const headingId = (0,dist_module/* useId */.Me)();
    if (Object.keys(filters).length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "type-filter-container",
        className: "dg gg4 pb12 dn-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gray600 fs14 lh22 font-im ttu ls12",
                id: headingId,
                children: i18n.t("Filter By")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "group",
                className: "df fw gg2",
                "aria-labelledby": headingId,
                children: Object.keys(filters).map((name, k)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "brdn ph3 pv2 font-ib fs14 lh22 br8 contrast-tb cp ".concat(filters[name] ? "bg-gray400 gray50 contrast-mark" : "bg-gray100 gray800"),
                        role: "switch",
                        "aria-checked": filters[name],
                        onClick: ()=>toggleFilter(name),
                        children: name
                    }, k))
            })
        ]
    });
};
/* harmony default export */ var RegionalInsuranceList_TypeFilter = (/*#__PURE__*/react.memo(TypeFilter));

// EXTERNAL MODULE: ./src/components/v5/Region/RegionTreeSelector.tsx + 5 modules
var RegionTreeSelector = __webpack_require__(93994);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var src_store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/constants/hardcodedVirtualRegions.ts
var hardcodedVirtualRegions = __webpack_require__(96821);
// EXTERNAL MODULE: ./src/utils/getPricingTierBySlug.ts + 1 modules
var getPricingTierBySlug = __webpack_require__(67350);
;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/RegionFilter.tsx



const RegionFilter = (param)=>{
    let { children  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tac ma pb8 pb0-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-i fs24 fs18-sm lh13 gray600 mb4 db",
                children: i18n.t("Choose your region")
            }),
            children
        ]
    });
};
/* harmony default export */ var RegionalInsuranceList_RegionFilter = (RegionFilter);

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/SearchFilter.tsx



const SearchFilter = (param)=>{
    let { searchText ="" , setSearchText , isExpanded =false  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [_isExpanded, setIsExpanded] = (0,react.useState)(isExpanded);
    (0,react.useEffect)(()=>{
        setIsExpanded(isExpanded);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "search-filter",
        role: "search",
        className: "df aic ass bg-gray100 br8 mb8 contrast-tb",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": _isExpanded ? i18n.t("Hide Search") : i18n.t("Show Search"),
                style: {
                    height: 46,
                    width: 46
                },
                className: "br50 bg-gray100 brdn contrast-tb",
                onClick: ()=>setIsExpanded(!_isExpanded),
                "aria-expanded": _isExpanded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": true,
                    className: "cIcon-search fs22 gray800"
                })
            }),
            _isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                placeholder: i18n.t("Find a service..."),
                className: "br8 pv2 pr1 bg-gray100 font-ir brdn contrast-tb",
                value: searchText,
                type: "text",
                onChange: (e)=>setSearchText(e.target.value),
                "aria-label": i18n.t("Search prices")
            })
        ]
    });
};
/* harmony default export */ var RegionalInsuranceList_SearchFilter = (SearchFilter);

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/PricingItem.tsx




const PricingItem = (param)=>{
    let { typ , name , price , slug  } = param;
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const addendum = typ === "Visit" || name.match(/covid/gi) ? "" : "+ ".concat(i18n.t("visit price"));
    const displayPrice = "$".concat(price / 100);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "dg aic bg-white br2 pv4 pl5 pr5 ph3-md pv3-md gg4 contrast-tbb",
        style: {
            gridTemplateColumns: isSm ? "auto 1fr auto" : "auto 1fr 160px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": true,
                style: {
                    height: 50,
                    width: 50
                },
                className: "bg-lightMint gray600 br50 tac fs24 df aic jcc contrast-tb cIcon-".concat(slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "fs20 fs16-md fs14-sm font-im ls-5 lh15",
                children: i18n.t(name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "dg df-sm fdc aic aife-sm gg2 gg0-sm gray800 font-im fs24 fs16-md lh13",
                style: {
                    gridTemplateColumns: "auto 1fr"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: displayPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gray600 font-ir fs16 lh2 fs14-md",
                        children: addendum
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RegionalInsuranceList_PricingItem = (PricingItem);

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/SectionGroup.tsx



const SectionGroup = (param)=>{
    let { title , items  } = param;
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "section-group-".concat(title),
        className: "pb12 pb8-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "gray600 fs14 ls12 ttu font-im pb6 pb3-sm",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "dg gg2 gafr",
                children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_PricingItem, {
                        ...item
                    }, item.slug))
            })
        ]
    });
};
/* harmony default export */ var RegionalInsuranceList_SectionGroup = (/*#__PURE__*/react.memo(SectionGroup));

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/SectionGroupList.tsx



const SectionGroupList = (param)=>/*#__PURE__*/ {
    let { pricesGroupedByType  } = param;
    return (0,jsx_runtime.jsx)("div", {
        "data-testid": "section-group-list",
        children: Object.keys(pricesGroupedByType).map((name)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_SectionGroup, {
                title: name,
                items: pricesGroupedByType[name]
            }, "section-".concat(name)))
    });
};
/* harmony default export */ var RegionalInsuranceList_SectionGroupList = (/*#__PURE__*/react.memo(SectionGroupList));

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/utils.ts

const merge = (prev, curr)=>({
        ...prev,
        [curr]: false
    });
const toFilterMap = (filters)=>filters.reduce(merge, {});
const toggleFilter = (filter, filterMap)=>({
        ...filterMap,
        [filter]: !filterMap[filter]
    });
const useFilters = (initialFilters)=>{
    const defaultFilters = (0,react.useMemo)(()=>toFilterMap(initialFilters), [
        initialFilters
    ]);
    const [filters, setFilters] = (0,react.useState)(defaultFilters);
    const _toggleFilter = (0,react.useCallback)((filter)=>{
        setFilters(toggleFilter(filter, filters));
    }, [
        filters
    ]);
    return {
        filters,
        toggleFilter: _toggleFilter
    };
};
const getFilteredGroupList = function(prices, filters) {
    let searchText = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", // @ts-expect-error TS7006: Parameter 'isVirtual' implicitly has an 'any' type.
    isVirtual = arguments.length > 3 ? arguments[3] : void 0;
    const activeFilters = filters.pickBy((item)=>item === true).getKeys();
    const filteredPrices = prices.filterIf(searchText.length > 0, (param)=>{
        let { name  } = param;
        return name.toLocaleLowerCase().includes(searchText.toLowerCase());
    }).filterIf(isVirtual, (param)=>{
        let { name  } = param;
        return name.toLocaleLowerCase().includes("virtual");
    }).filterIf(activeFilters.length > 0, (param)=>{
        let { typ  } = param;
        return activeFilters.some((f)=>f === typ);
    });
    return filteredPrices.groupBy("typ");
};

;// CONCATENATED MODULE: ./src/components/v5/Pricing/RegionalInsuranceList/RegionalInsuranceList.tsx














const RegionalInsuranceList = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const isMd = (0,useMediaQuery/* default */.Z)("md");
    const selectedRegion = (0,src_store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const pricingData = (0,src_store/* useTypedSelector */.ix)((state)=>state.regionPricing);
    const initialPrices = pricingData[(0,getPricingTierBySlug/* getPricingTierByRegionSlug */.i)(selectedRegion)];
    const [prices, setPrices] = (0,react.useState)(initialPrices);
    const types = react.useRef(prices.map((p)=>p.typ).distinct()).current;
    const { filters , toggleFilter  } = useFilters(types);
    const [searchText, setSearchText] = (0,react.useState)("");
    const pricesGroupedByType = (0,react.useMemo)(()=>getFilteredGroupList(prices, filters, searchText, hardcodedVirtualRegions/* default.some */.Z.some((param)=>{
            let { slug  } = param;
            return slug === selectedRegion;
        })), [
        prices,
        filters,
        searchText,
        selectedRegion
    ]);
    const numberOfResults = Object.values(pricesGroupedByType).reduce((total, current)=>total + current.length, 0);
    (0,react.useEffect)(()=>{
        setPrices(pricingData[(0,getPricingTierBySlug/* getPricingTierByRegionSlug */.i)(selectedRegion)]);
    }, [
        selectedRegion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        "aria-label": i18n.t("Our Prices"),
        className: "pt20 pb26 bg-gray50 contrast-tbb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw70 ma ph8-xl ph4-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "tac mb4 fs48 fs28-sm lh12 gray800",
                    children: i18n.t("Clear costs, great care")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_RegionFilter, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTreeSelector/* default */.Z, {
                                buttonVariant: "secondary"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df jcc-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_TypeFilter, {
                            filters: filters,
                            toggleFilter: toggleFilter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_SearchFilter, {
                            isExpanded: isMd,
                            searchText: searchText,
                            setSearchText: setSearchText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    "aria-live": "polite",
                    children: numberOfResults ? i18n.t("{{count}} results found", {
                        count: numberOfResults
                    }) : i18n.t("No results found for selected criteria")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_SectionGroupList, {
                    pricesGroupedByType: pricesGroupedByType
                })
            ]
        })
    });
};
/* harmony default export */ var RegionalInsuranceList_RegionalInsuranceList = (/*#__PURE__*/react.memo(RegionalInsuranceList));

// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./src/_services/featureFlags.ts
var _services_featureFlags = __webpack_require__(30660);
// EXTERNAL MODULE: ./src/components/v5/Faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(73349);
// EXTERNAL MODULE: ./src/constants/InsurancePricingConstants.tsx
var InsurancePricingConstants = __webpack_require__(50815);
// EXTERNAL MODULE: ./src/utils/fetchPricingData.ts
var fetchPricingData = __webpack_require__(37059);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Pricing/Billing.tsx










const Billing = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const trackPhoneClick = (phoneNumber)=>{
        const phoneClickEvent = {
            category: analytics/* analytics.category.SUPPORT */.c.category.SUPPORT,
            label: analytics/* analytics.label.CONTACT_SUPPORT */.c.label.CONTACT_SUPPORT,
            action: analytics/* analytics.action.CLICKED */.c.action.CLICKED,
            value: phoneNumber
        };
        analytics/* analytics.post */.c.post(phoneClickEvent);
    };
    const modes = [
        {
            icon: "profile-picture",
            color: palette.yellow,
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Pre-Visit",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Patient Inquiries"
                ]
            }),
            text: i18n.t("Every Day\n9:30 AM to 6:00 PM Pacific"),
            email: "support@carbonhealth.com",
            bottom: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-ir gray600 fs12 lh15",
                        children: i18n.t("Call your clinic directly")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: _constants/* v5Pages.locations */.Td.locations,
                        style: {
                            textUnderlineOffset: 2
                        },
                        className: "tdu darkBlue font-ib fs12 lh15",
                        children: "carbonhealth.com/locations"
                    })
                ]
            })
        },
        {
            icon: "hand-phone-cross",
            color: palette.lightBlue,
            title: i18n.t("Patient Billing Questions"),
            text: i18n.t("Monday - Friday\n9:30 AM to 5:00 PM Pacific"),
            email: "billing@carbonhealth.com",
            phoneNumber: InsurancePricingConstants/* PHONE_NUMBERS.MAIN */.u.MAIN
        },
        {
            icon: "hands-cross",
            color: palette.lightPurple,
            title: i18n.t("Insurance Companies"),
            text: i18n.t("You can directly contact our insurance and billing representatives."),
            email: "billing@carbonhealth.com",
            phoneNumber: InsurancePricingConstants/* PHONE_NUMBERS.MAIN */.u.MAIN,
            bottom: ""
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-label": i18n.t("Billing Support"),
        className: "bg-gray100 df fdc jcc pb46 pb20-md pt28 pt10-md tac contrast-tbt",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "df aic fdc mb24 mb6-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "ttu fs13 gray400 font-isb ls2 lh18 mb8",
                        children: i18n.t("Billing Support")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        className: "fs40 fs30-sm gray800 tdn font-cm",
                        children: [
                            i18n.t("Still have questions?"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                className: "dn db-md"
                            }),
                            " ",
                            i18n.t("We have answers.")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "dg gg6 gtc3fr df-lg fdc maxw70 ma ph4-xl",
                children: modes.map((m)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "ph12 ph4-xl ph8-lg pv20 bg-white br8 mb4-md maxw25 contrast-tb",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "aria-hidden": true,
                                    className: "cIcon-".concat(m.icon, " br50 mb3 df jcc aic fs40"),
                                    style: {
                                        height: 68,
                                        width: 68,
                                        backgroundColor: m.color
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "fs32 fs28-lg font-c maxw32 lh12 mb5",
                                    children: m.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-ir fs14 lh14 gray400 mb12 maxw16",
                                    children: m.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                    fontSize: 0.75,
                                    className: "mb3 gray50-f font-ib-f bg-gray800-f contrast-tb-f",
                                    href: "mailto:".concat(m.email),
                                    children: m.email
                                }),
                                m.phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                    fontSize: 0.75,
                                    bg: "#fff",
                                    className: "p3-f brd2nc-f brd-gray800-f",
                                    color: palette.gray800,
                                    onClick: ()=>trackPhoneClick(m.phoneNumber),
                                    href: "tel:".concat(m.phoneNumber),
                                    children: (0,Carbon/* formatPhoneNumber */.un)(m.phoneNumber)
                                }),
                                m.bottom && m.bottom
                            ]
                        })
                    }, m.icon))
            })
        ]
    });
};
/* harmony default export */ var Pricing_Billing = (Billing);

// EXTERNAL MODULE: ./src/components/v5/Reason/Insurances.tsx
var Insurances = __webpack_require__(3250);
;// CONCATENATED MODULE: ./src/components/v5/Pricing/Header.tsx





const Header = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-darkerBlue pt50 pt34-lg pt24-sm contrast-tbb",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurances/* default */.ZP, {
                headerText: i18n.t("We accept most major insurance plans. No insurance? See our affordable prices before you book."),
                isFullWidth: true,
                phoneNumber: InsurancePricingConstants/* PHONE_NUMBERS.MAIN */.u.MAIN
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "minh30 w100p bgpc",
                style: {
                    backgroundImage: "url(/static/img/v5/patterns/splatter.webp)"
                }
            })
        ]
    });
};
/* harmony default export */ var Pricing_Header = (Header);

// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
;// CONCATENATED MODULE: ./src/pages/insurance-pricing.tsx















const InsurancePricing = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { faq  } = (0,InsurancePricingConstants/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("Insurance & Pricing | Accepting All Major Insurance Providers | Carbon Health"),
        pageDescription: i18n.t("Carbon Health aims to make health high-quality healthcare accessible to all. We accepts all major insurance providers including medicare, cash payments, FSA & HSA."),
        pageImage: "insurance-pricing-05032022",
        navTheme: useNavState/* NavTheme.LIGHT */.Xm.LIGHT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionalInsuranceList_RegionalInsuranceList, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                className: "maxw75-f",
                faq: faq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_Billing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {})
        ]
    });
};
InsurancePricing.getInitialProps = async (param)=>{
    let { req , store  } = param;
    const pricingData = await (0,fetchPricingData/* fetchPricingData */.H)();
    const { featureFlags  } = store.getState();
    if (featureFlags.GROWTH_HRSA_FAQ_CHANGES_ENABLED === undefined) {
        await (0,_services_featureFlags/* fetchFeatureFlags */.Vw)({
            [featureFlagConstants/* FeatureFlag.GROWTH_HRSA_FAQ_CHANGES_ENABLED */.T.GROWTH_HRSA_FAQ_CHANGES_ENABLED]: true
        }, {
            dispatch: store.dispatch,
            req
        });
    }
    store.dispatch(src_store/* actions.setRegionPricing */.Nw.setRegionPricing(pricingData));
    return {};
};
/* harmony default export */ var insurance_pricing = (InsurancePricing);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,2493,6282,2122,620,2320,9774,2888,179], function() { return __webpack_exec__(92596); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);